import type { ReactNode } from 'react';
import React, { Children, isValidElement } from 'react';

import { useTabs } from '../Tabs';

type TabListProps = {
  children?: ReactNode;
};

type TabChildProps = {
  id?: string;
  'aria-controls'?: string;
  isActive?: boolean;
  isDisabled?: boolean;
  onSelect?: (event: React.MouseEvent | React.KeyboardEvent) => void;
};

function TabList({ children }: TabListProps) {
  const { activeIndex, id, onSelectTab, onChange } = useTabs();
  return (
    <div className="TabList" role="tablist">
      {Children.map(children, (child, index) => {
        if (!isValidElement<TabChildProps>(child)) {
          return null;
        }
        return React.cloneElement(child, {
          id: `${id}-tab-${index}`,
          'aria-controls': `${id}-panel-${index}`,
          isActive: index === activeIndex,
          onSelect: (event: React.MouseEvent | React.KeyboardEvent) => {
            event.preventDefault();
            if (child.props?.isDisabled) {
              return;
            }
            onSelectTab(index);
            onChange({ index });
          },
        });
      })}
    </div>
  );
}

TabList.displayName = 'TabList';

export { TabList };
